<template>
  <el-container class="login" v-loading="loading">
    <common-aside></common-aside>
    <el-main class="content">
      <div class="login-banner">
        <img src="../../assets/img/thank-nav-banner.png" alt="Christmas Day" />
      </div>
      <div class="header" :class="{ scroll: hasScroll === true }">
        <div class="logo">
          <a href="https://asogrow.net/" target="_blank">
            <img src="../../assets/img/logo.svg" alt="LOGO" class="logo-img" />
          </a>
        </div>
        <div class="rightWrap">
          <p class="rightWrap-text">{{ $t('messages.login.loginText') }}</p>
          <div class="langBtn" @click="changeLang('login')">EN/CN</div>
          <div class="signup overlay-btn" @click="goRegister">
            <span>{{ $t('messages.login.signUpBtn') }}</span>
          </div>
          <div class="banner-logo">
            <img src="../../assets/img/thank-login-logo.png" alt="LOGO" class="logo-img" />
          </div>
        </div>
      </div>
      <div class="main-container">
        <el-scrollbar style="height: 100%;width: 100%;" ref="scrollbar">
          <el-form
            :model="login"
            v-if="page_level == 1"
            :rules="rules"
            ref="loginForm"
            class="login-form"
          >
            <div class="login-title" style="align-items: center;">
              <div>{{ $t('messages.login.loginText') }}</div>
              <div class="signup overlay-btn" @click="goRegister">
                <span>{{ $t('messages.login.signUpBtn') }}</span>
              </div>
            </div>
            <el-tabs v-model="activeName" class="head-tabs">
              <el-tab-pane :label="$t('messages.login.email')" name="email">
                <template v-if="activeName === 'email'">
                  <el-form-item prop="username">
                    <el-input
                      class="login-input"
                      type="text"
                      autocomplete="off"
                      v-model="login.username"
                      name="username"
                      :placeholder="$t('messages.login.emailInput')"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input
                      class="login-input"
                      type="password"
                      autocomplete="off"
                      v-model="login.password"
                      name="password"
                      @keyup.native="$event.keyCode == 13 ? Login() : ''"
                      :placeholder="$t('messages.login.passInput')"
                    ></el-input>
                  </el-form-item>
                  <el-form-item v-if="login_captcha_enable" prop="captcha">
                    <label class="ym-label">Verification Code</label>
                    <el-input
                      class="login-input"
                      v-model="login.captcha"
                      name="captcha"
                      @keyup.native="$event.keyCode == 13 ? Login() : ''"
                    >
                      <template slot="append">
                        <img
                          id="login_captcha"
                          class="captcha-img"
                          @click="src = '/api/data/get-captcha/?' + Math.random()"
                          :src="src"
                          alt="captcha"
                          style="vertical-align: middle;height: 46px;"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <div class="remember-box">
                      <div>
                        <a class="forget" @click="page_level = 4">
                          {{ $t('messages.login.forgetPassword') }}
                        </a>
                      </div>
                    </div>
                  </el-form-item>
                </template>
              </el-tab-pane>
              <el-tab-pane :label="$t('messages.login.phone')" name="phone">
                <template v-if="activeName === 'phone'">
                  <el-form-item prop="phone" class="application-number application-number2">
                    <el-input
                      v-model="login.phone"
                      :placeholder="$t('messages.register.phoneTip')"
                      class="login-input"
                    >
                      <el-select
                        v-model="area"
                        slot="prepend"
                        size="medium"
                        filterable
                        popper-class="app-select area-code-select"
                        :placeholder="$t('messages.other.other54')"
                      >
                        <el-option
                          v-for="(item, i) in areaCodeList"
                          :key="i"
                          :label="item.code + '     ' + item.country"
                          :value="item.country"
                        >
                          <p class="option-p">
                            <span>{{ item.code }}</span>
                            <span>{{ item.country }}</span>
                          </p>
                        </el-option>
                      </el-select>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="code" class="captcha captcha-send-code">
                    <el-input
                      v-model="login.code"
                      name="code"
                      :placeholder="$t('messages.register.code')"
                      class="login-input"
                    >
                      <template slot="append">
                        <div class="send-code" @click="sendCode" id="send-code">
                          <p id="send-tit">{{ $t('messages.login.send') }}</p>
                          <p id="sending">
                            <span style="margin-right: 2px;">{{ $t('messages.login.resend') }}</span>
                            <span id="countdown-text" style="width: 26px;">(60)</span>
                          </p>
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                  <!-- <slider-component></slider-component>
                  <SliderVerify
                    :isShowSelf.sync="sliderVConf.isShowSelf"
                    :imgUrl="sliderVConf.imgUrl"
                    :sText="sliderVConf.sText"
                    :eText="sliderVConf.eText"
                    :isBorder="sliderVConf.isBorder"
                    :isParentNode="sliderVConf.isParentNode"
                    :isCloseBtn="sliderVConf.isCloseBtn"
                    :isReloadBtn="sliderVConf.isReloadBtn"
                    :isShowTip="sliderVConf.isShowTip"
                    :width="sliderVConf.width"
                    :height="sliderVConf.height"
                    @reload="emitChange('reload')"
                    @show="emitChange('show')"
                    @hide="emitChange('hide')"
                    @close="emitChange('close')"
                    @success="emitChange('success')"
                    @fail="emitChange('fail')"
                  ></SliderVerify> -->
                </template>
              </el-tab-pane>
            </el-tabs>
            <el-form-item>
              <el-button class="login-btn overlay-btn" type="primary" @click="Login">
                {{ $t('messages.login.loginText') }}
              </el-button>
            </el-form-item>
          </el-form>

          <!--忘记密码-->
          <el-form
            v-if="page_level == 4"
            :model="emailForm"
            ref="emailForm"
            :rules="emailRules"
            @submit.native.prevent
            class="reset-psw-form"
          >
            <h2 class="reset-psw-title" style="margin-top:0">
              <div :style="{ 'margin-bottom': $i18n.locale === 'zh' ? '24px' : '0' }">
                {{ $t('messages.forget.title') }}
              </div>
              <div :style="{ 'font-size': $i18n.locale === 'zh' ? '16px' : '20px' }">
                {{ $t('messages.forget.subTitle') }}
              </div>
            </h2>
            <el-form-item prop="verify_email">
              <label class="ym-label">{{ $t('messages.forget.email') }}</label>
              <el-input
                class="reset-psw-input"
                type="email"
                autocomplete="off"
                :placeholder="$t('messages.forget.emailInput')"
                v-model="emailForm.email"
                @keyup.native.stop="$event.keyCode == 13 ? onVerify() : ''"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <label class="ym-label">{{ $t('messages.forget.code') }}</label>
              <el-input
                class="reset-psw-input"
                v-model="emailForm.captcha"
                name="captcha"
                @keyup.native="$event.keyCode == 13 ? onVerify() : ''"
              >
                <template slot="append">
                  <img
                    id="reset_psw_captcha"
                    class="captcha-img"
                    @click="src = '/api/data/get-captcha/?' + Math.random()"
                    :src="src"
                    alt="captcha"
                  />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="reset-psw-btn overlay-btn" type="primary" @click="onVerify">
                {{ $t('messages.forget.confirm') }}
              </el-button>
              <div class="reset-psw-back">
                <a @click="page_level = 1">{{ $t('messages.forget.back') }}</a>
              </div>
            </el-form-item>
          </el-form>

          <!--重置密码邮件发送-->
          <div v-if="page_level === 5" class="reset-psw-success">
            <h2>
              <i class="icon-y-success mr-1"></i>
              {{ $t('messages.forgets.title') }}
            </h2>
            <div>
              <div class="sub-tit">{{ $t('messages.forgets.subtitle') }}</div>
              <div class="email">{{ emailForm.email }}</div>
              <div class="content">
                {{ $t('messages.forgets.content1') }}
                <br />
                {{ $t('messages.forgets.content2') }}
              </div>
            </div>
            <el-button type="primary" class="check-btn overlay-btn" @click="checkResetPswEmail">
              {{ $t('messages.forgets.btn') }}
            </el-button>
          </div>

          <google-btn v-if="page_level !== 5" :key="$i18n.locale" :query="query"></google-btn>

          <!-- 移动端切换语言按钮 -->
          <div class="lang-switch-wrap">
            <div class="lang-switch" id="lang-switch" @click="changeLang('login')">
              <div :class="{ 'lang-icon': true, langActive: this.$i18n.locale === 'en' }">EN</div>
              <div :class="{ 'lang-icon': true, langActive: this.$i18n.locale === 'zh' }">CN</div>
            </div>
          </div>
          <div class="copyright">
            <span class="copyright-p">© 2022 有米科技股份有限公司 版权所有</span>
            <span class="copyright-p" @click="handleDomain">粤ICP备11022409号</span>
            <span class="copyright-p" @click="handleGo">粤公网安备44011302003751号</span>
          </div>
          <div class="copyright-mobile">
            <span class="copyright-p">© 2022 有米科技股份有限公司 版权所有</span>
            <span class="copyright-p" @click="handleDomain">备11022409号</span>
            <span class="copyright-p" @click="handleGo">粤公网安备44011302003751号</span>
          </div>
        </el-scrollbar>
      </div>
    </el-main>
    <!-- <contact-box></contact-box> -->

    <el-dialog
      :visible.sync="registerDialog"
      width="560px"
      :close-on-click-modal="false"
      :title="$t('messages.login.registerSuccess')"
    >
      <div class="noAppDialog">
        <p>{{ $t('messages.login.tip1') }}</p>
        <p>{{ $t('messages.login.tip2') }}</p>
        <div class="btns">
          <el-button class="btn1" @click="goNext">{{ $t('messages.login.next') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="codeFailDialog"
      width="560px"
      :close-on-click-modal="false"
      :title="$t('messages.createCampaign.create156')"
    >
      <div class="noAppDialog">
        <p>{{ $t('messages.tipError.sendErr1') }}</p>
        <p>{{ $t('messages.tipError.sendErr2') }}</p>
        <p v-if="codeFailTip !== 'Not OK'">{{ $t('messages.tipError.sendErr3') }}:{{ codeFailTip }}</p>
        <div class="btns">
          <el-button class="btn1" @click="contactUS">{{ $t('messages.tipError.sendErr4') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import commonAside from '@/components/commonAside'
import googleBtn from '@/components/googleBtn'
import loginAndRegisterMixin from '@/mixins/loginAndRegisterMixin'

let countdownInterval;
export default {
  components: { commonAside, googleBtn },
  mixins:[ loginAndRegisterMixin ],
  data() {
    return {
      sliderVConf: {
        isShowSelf: true,
        width: 300,
        height: 180,
        imgUrl: '',
        sText: 'success',
        eText: 'failed',
        isBorder: true,
        isCloseBtn: true,
        isReloadBtn: true,
        isParentNode: false,
        isShowTip: true,
      },

      loading: false,
      src: '/api/data/get-captcha/',
      signAsRole: '',
      page_level: 1,
      login: {
        phone: '',
        code: '',
      },
      login_captcha_enable: false,
      emailForm: {},
      rules: {},
      emailRules: {},
      source: 'Official',
      pl: '',
      query: 's=Official',
      hasScroll: false,
      activeName: 'email',
      areaCodeList: [],
      area: '',
      registerDialog: false,
      codeFailDialog: false,
      intervalId: null,
      maxExecutions: 60,
      executionCount: 0,
      codeFailTip:'',
      lunxunPhone: '',
    }
  },
  created() {
    this.$http.get('/api/accounts/profile/').then(res => {
      if (res.status === 0) {
        this.routerChange('snapshot')
      }
    })
    let s = this.$route.query.s
    if (s) {
      this.source = this.$route.query.s
    }
    this.pl = this.$route.query.pl
    this.query = `s=${this.source}`
    if (this.pl) {
      this.query = this.query + '&pl=' + this.pl
    }
    this.setFormRules()
    this.getAreaCodeList()
  },
  mounted() {
    this.headerScroll()
  },
  beforeDestroy() {
    // 清除定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
  },
  watch: {
    '$i18n.locale': function() {
      this.setFormRules()
      this.$nextTick(() => {
        if (this.$refs['loginForm']) {
          this.$refs['loginForm'].fields.forEach(item => {
            item.clearValidate()
            // if(item.validateState !== 'error'){
            //   this.$refs['loginForm'].clearValidate([item.prop])
            // }
          })
        }
        if (this.$refs['emailForm']) {
          this.$refs['emailForm'].fields.forEach(item => {
            item.clearValidate()
          })
        }
      })
    },
  },
  computed: {
    areaPhone() {
      let str = ''
      let phone = this.login.phone
      let newPhone = ''
      let country = this.areaCodeList.filter(row => row.country === this.area)
      if (country.length > 0) {
        str = country[0].code
        newPhone = str + phone
      }
      return newPhone
    },
  },
  methods: {
    contactUS() {
      this.codeFailDialog = false
      this.$EventBus.$emit('showContact')
      this.OpenTawkChat()
    },
    goNext() {
      this.registerDialog = false
      this.routerChange('snapshot')
    },
    emitChange(type) {
      console.log('emitChange', type)
    },
    handleCountdown() {
      // this.sending = true;
      // 初始化倒计时时间（秒）
      let timeLeft = 60
      // 获取显示倒计时的元素
      let dom = document.getElementById('send-tit')
      let dom2 = document.getElementById('sending')
      let dom3 = document.getElementById('countdown-text')
      let dom4 = document.getElementById('send-code')
      this.sending = true
      // 创建一个每秒更新一次倒计时的函数
      countdownInterval = setInterval(() => {
        console.log('countdownInterval');
        // 更新倒计时显示
        dom.style.display = 'none'
        dom2.style.display = 'block'
        dom4.style.background = '#909399'
        dom3.textContent = `(${timeLeft})`
        // 检查倒计时是否结束
        if (timeLeft < 0) {
          // 清除定时器
          clearInterval(countdownInterval)
          dom.style.display = 'block'
          dom2.style.display = 'none'
          dom4.style.background = '#E9077C'
          this.sending = false
        } else {
          // 减少倒计时时间
          timeLeft--
        }
      }, 1000) // 1000毫秒 = 1秒
    },
    // 定义要执行的任务函数
    executeTask() {
      // console.log("Task executed at " + new Date().toLocaleTimeString());
      // 增加执行次数
      this.executionCount++
      // 检查是否达到了最大执行次数
      if (this.executionCount >= this.maxExecutions) {
        // 清除定时器
        clearInterval(this.intervalId)
        // console.log("Timer stopped at " + new Date().toLocaleTimeString());
      } else {
        let params = {
          phone: this.lunxunPhone,
          typ: 'login',
          lang: this.$i18n.locale,
        }
        this.$http
          .post('/api/accounts/send-sms/result/', params)
          .then(res => {
            if (res.data.send_status === 1) {
              clearInterval(this.intervalId)
            } else if (res.data.send_status !== 0) {
              this.codeFailDialog = true
              this.codeFailTip = res.data.msg
              clearInterval(this.intervalId)
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    handleCountdown2() {
      // 设置定时器，每两秒执行一次 executeTask 函数
      this.intervalId = setInterval(this.executeTask, 2000)
    },
    sendCode() {
      if (!this.sending) {
        this.$refs.loginForm.validateField('phone', error => {
          if (!error) {
            let params = {
              phone: this.areaPhone,
              typ: 'login',
            }
            this.$http
              .post('/api/accounts/send-sms/', params)
              .then(() => {
                this.notifyOpen('Success', this.$t('messages.register.codeSended'))
                this.handleCountdown()
                this.lunxunPhone = this.areaPhone
                this.handleCountdown2()
              })
              .catch(error => {
                if (error.c === -1301) {
                  this.notifyOpen('Error', this.$t('messages.register.codeAgain'), 'error')
                }else if (error.c === -1404) {
                  this.notifyOpen('Error', this.$t('messages.register.codeAgain2'), 'error')
                }else if (error.c === -1405) {
                  this.notifyOpen('Error', this.$t('messages.tipError.phoneCodeErr'), 'error')
                }else {
                  this.notifyOpen('Error', error.m || this.$t('messages.tipError.timeout'), 'error')
                }
              })
          }
        })
      }
    },
    getAreaCodeList() {
      this.$http
        .get('/api/accounts/get_phone_area_code/')
        .then(data => {
          this.areaCodeList = data.data
          this.area = data.country
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    headerScroll() {
      let scrollEl = this.$refs.scrollbar.wrap
      scrollEl.onscroll = () => {
        if (scrollEl.scrollTop > 0) {
          this.hasScroll = true
        } else {
          this.hasScroll = false
        }
      }
    },
    setFormRules() {
      this.rules = {
        username: [
          { required: true, message: this.$t('messages.login.emptyErr'), trigger: 'blur' },
          { type: 'email', message: this.$t('messages.login.formatErr'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('messages.login.emptyErr'), trigger: 'blur' },
        ],
        captcha: [
          { required: true, message: this.$t('messages.login.emptyErr'), trigger: ['blur'] },
          { validator: this.verifyCaptcha, trigger: ['blur'] },
        ],
        phone: [
          {
            required: true,
            message: this.$t('messages.register.phoneFormatErr'),
            trigger: ['blur'],
          },
          // {validator: this.validatePhone, trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const regex = /\D/
              let phoneRegex = /^1[3-9]\d{9}$/ // 手机号正则表达式
              if (this.area !== 'CN') {
                if (regex.test(value)) {
                  return callback(new Error(this.$t('messages.register.phoneErr1')))
                } else if (value.length > 20) {
                  return callback(new Error(this.$t('messages.register.phoneErr3')))
                } else {
                  callback()
                }
              } else {
                if (!phoneRegex.test(value)) {
                  if (regex.test(value)) {
                    return callback(new Error(this.$t('messages.register.phoneErr1')))
                  } else {
                    return callback(new Error(this.$t('messages.register.phoneErr2')))
                  }
                } else {
                  callback()
                }
              }
            },
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: this.$t('messages.register.verificationCodeEmpty'),
            trigger: ['blur'],
          },
          {
            validator: (rule, value, callback) => {
              const regex = /^[0-9A-Za-z]{6}$/ // 手机号正则表达式
              if (!regex.test(value)) {
                callback(new Error(this.$t('messages.register.verificationCodeDigit')))
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
      }
      this.emailRules = {
        email: [
          { required: true, message: this.$t('messages.forget.emptyErr'), trigger: ['blur'] },
          { type: 'email', message: this.$t('messages.forget.formatErr'), trigger: ['blur'] },
        ],
        captcha: [
          { required: true, message: this.$t('messages.forget.emptyErr'), trigger: ['blur'] },
          { validator: this.verifyCaptcha, trigger: ['blur'] },
        ],
      }
    },
    handleDomain() {
      window.open('https://beian.miit.gov.cn', '_blank')
    },
    handleGo() {
      window.open(
        'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011302003751',
        '_blank'
      )
    },
    // changeLang() {
    //   let str = this.$i18n.locale
    //   if (str === 'zh') {
    //     this.$i18n.locale = 'en'
    //     this.$router.push({ path: '/en-us/login' })
    //   } else {
    //     this.$i18n.locale = 'zh'
    //     this.$router.push({ path: '/zh-cn/login' })
    //   }
    // },
    // goRegister(){
    //   let str = this.$i18n.locale
    //   if (str === 'zh') {
    //     this.$router.push({ path: '/zh-cn/register' })
    //   } else {
    //     this.$router.push({ path: '/en-us/register' })
    //   }
    // },
    Login() {
      this.$refs['loginForm'].validate(valid => {
        if (valid) {
          this.loading = true
          let { username, code, password } = this.login
          let login_url = ''
          let params = {}
          if (this.activeName === 'email') {
            params.username = username
            params.password = password
            login_url = '/api/accounts/login/'
          } else {
            params.phone = this.areaPhone
            params.code = code
            login_url = '/api/accounts/login-with-phone/'
          }
          if (window.location.search) {
            login_url = login_url + window.location.search
          }
          this.$http
            .post(login_url, params)
            .then(res => {
              this.loading = false
              if (this.activeName === 'phone' && res.register === 1) {
                this.registerDialog = true
              } else {
                this.routerChange('snapshot')
              }
            })
            .catch(err => {
              this.loading = false
              let captcha = document.getElementById('login_captcha')
              if (captcha) {
                captcha.src = '/api/data/get-captcha/'
                this.captcha_status = false
              }
              switch (err.c) {
                case -1006: // 邮箱未验证
                  break
                case -1031: // captcha error
                  this.login_captcha_enable = true
                  this.notifyOpen('Error', this.$t('messages.tipError.codeErr'), 'error')
                  break
                case -1116: // Invalid email or password
                  this.notifyOpen('Error', this.$t('messages.tipError.loginErr'), 'error')
                  break
                case -1113: // AccountNotActive
                  this.notifyOpen('Error', this.$t('messages.tipError.accountNotActive'), 'error')
                  break
                case -2: // SrvErr
                  this.notifyOpen('Error', this.$t('messages.tipError.srvErr'), 'error')
                  break
                case -1005: // PostOnly
                  this.notifyOpen('Error', this.$t('messages.tipError.postOnly'), 'error')
                  break
                case -1: // PostOnly
                  this.notifyOpen('Error', this.$t('messages.tipError.invalidCodeErr'), 'error')
                  break
                default:
                  // network error
                  this.notifyOpen('Error', this.$t('messages.tipError.netErr'), 'error')
              }
            })
        }
      })
    },

    verifyCaptcha(rule, value, callback) {
      let item = {}
      if (this.page_level === 1) {
        item.captcha = this.login.captcha
      }
      if (this.page_level === 4) {
        item.captcha = this.emailForm.captcha
      }
      this.$http
        .post('/api/data/check-captcha/', item)
        .then(() => {
          callback()
        })
        .catch(() => {
          callback(new Error(this.$t('messages.forget.codeErr')))
        })
    },
    onVerify() {
      let verify = true
      let params = this.emailForm
      this.$refs['emailForm'].validate(valid => {
        if (!valid) {
          verify = false
        }
      })
      if (!verify) {
        return
      }

      this.$http
        .post('/api/accounts/forget/', params)
        .then(() => {
          this.page_level = 5
        })
        .catch(err => {
          let captcha = document.getElementById('reset_psw_captcha')
          if (captcha) {
            captcha.src = '/api/data/get-captcha/'
          }
          switch (err.c) {
            case -1116: // PassWordRestLimitError
              this.notifyOpen('Error', this.$t('messages.tipError.limitErr'), 'error')
              break
            case -1031: // captcha error
              this.notifyOpen('Error', this.$t('messages.tipError.codeErr'), 'error')
              break
            case -1008: // EmailNotExists
              this.notifyOpen('Error', this.$t('messages.tipError.emailNotExists'), 'error')
              break
            case -1035: // EmailFail
              this.notifyOpen('Error', this.$t('messages.tipError.emailFail'), 'error')
              break
            default:
              // network error
              this.notifyOpen('Error', this.$t('messages.tipError.netErr'), 'error')
          }
        })
    },
    checkResetPswEmail() {
      let mailAddress = this.emailForm.email.split('@')[1]
      if (mailAddress) {
        if (mailAddress === 'gmail.com') {
          mailAddress = 'google.com'
        }
        window.open(`http://mail.${mailAddress}`, '_blank')
      }
    },
    sendEmailAgain() {
      let params = {
        email: this.login.username,
        template: 'account_active',
      }
      this.$http
        .post('/api/accounts/email-send/', params)
        .then(res => {
          this.notifyOpen(this.$t('messages.createCampaign.create202'))
        })
        .catch(err => {
          // this.notifyOpen('Error', this.executeError(err), 'error')
          switch (err.c) {
            case -1008: // EmailNotExists
              this.notifyOpen('Error', this.$t('messages.tipError.EmailNotExists'), 'error')
              break
            case -1007: // AlreadyVerify
              this.notifyOpen('Error', this.$t('messages.tipError.alreadyVerify'), 'error')
              break
            case -1006: // UnVerifyErr
              this.notifyOpen('Error', this.$t('messages.tipError.unVerifyErr'), 'error')
              break
            case -1121: // EmailExists
              this.notifyOpen('Error', this.$t('messages.tipError.emailExists'), 'error')
              break
            case -1038: // EmailCountLimit
              this.notifyOpen('Error', this.$t('messages.tipError.emailCountLimit'), 'error')
              break
            default:
              // network error
              this.notifyOpen('Error', this.$t('messages.tipError.netErr'), 'error')
          }
        })
    },
  },
  metaInfo() {
    // 当前路由和支持的语言
    const currentRoute = this.$route
    const supportedLangs = ['en', 'zh']
    const baseUrl = 'https://app.asogrow.net'
    // 获取当前路径并移除语言前缀
    const currentPath = currentRoute.path.replace(`/${currentRoute.params.lang}`, '') || '/'
    // 生成 hreflang 标签
    const hreflangLinks = supportedLangs.map(lang =>{
      let newLang = 'en-us';
      if(lang === 'zh'){
        newLang = 'zh-cn'
      }

      return {
        rel: 'alternate',
        hreflang: newLang,
        // href: `${baseUrl}/${lang}${currentRoute.path}`
        href: `${baseUrl}/${newLang}${currentPath}`
      }
    })

    // 添加 x-default 标签
    hreflangLinks.push({
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}/en-us${currentPath}`// currentRoute.path
    })

    return {
      title: this.$t('messages.login.metaTitle'),
      meta: [
        {
          name: 'description',
          content: this.$t('messages.login.metaDesc'),
          vmid: 'description',
        },
        {
          name: 'keywords',
          content: this.$t('messages.login.metaKeywords'),
          vmid: 'keywords',
        }
      ],
      link: hreflangLinks
    }

  }
}
</script>

<style lang="scss">
.test-flex {
  border: 1px solid;
  width: 1rem;
  height: 1rem;
  display: none;
}
.login {
  min-height: 100%;
  position: relative;
  display: flex;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  .icon-grey {
    font-size: 16px;
    color: #c0c4cc;
    line-height: 22px;
  }
  .captcha-img {
    vertical-align: middle;
    height: 46px;
  }
  .content {
    background-color: #fafcff;
    margin-bottom: 0px;
    // padding: 24px;
    padding: 0 0 24px;
    position: relative;
    z-index: 1;
    .login-banner {
      display: none;
    }
    .header {
      display: flex;
      justify-content: space-between;
      height: 40px;
      padding: 24px 40px 0 40px;
      .logo {
        margin-left: 16px;
        .logo-img {
          width: 175px;
          height: auto;
        }
      }
      .rightWrap {
        display: flex;
        align-items: center;
        position: relative;
        .rightWrap-text {
          display: none;
        }
        .banner-logo {
          width: 272px;
          height: 152px;
          position: absolute;
          top: 48px;
          right: -8px;
          z-index: 2;
          display: none;
          > img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .langBtn {
        width: 82px;
        height: 32px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e9077c;
        font-size: 14px;
        color: #e9077c;
        font-weight: 400;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        cursor: pointer;
      }
      a {
        text-decoration: none;
      }
      .signup {
        width: 80px;
        height: 32px;
        border-radius: 4px;
        background: #e30077;
        color: #fff;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
      }
      .signup::before {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
    .scroll {
      transition: padding 0.4s ease, margin-bottom 0.5s ease;
      padding: 8px 40px 8px 40px;
      box-shadow: 0px 4px 8px 0px rgba(33, 35, 41, 0.08);
      border: 1px solid rgba(235, 238, 245, 1);
      margin-bottom: 0;
    }
    .main-container {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      height: calc(100vh - 58px);
      .lang-switch-wrap {
        display: none;
      }
      .copyright,
      .copyright-mobile {
        width: 464px;
        margin: 30px auto 0;
        padding-bottom: 45px;
        // padding-bottom: 170px;
        .copyright-p {
          font-size: 13px;
          color: #c7cbd2;
          cursor: pointer;
          margin-right: 20px;
          &:first-child {
            cursor: inherit;
          }
          &:last-child {
            margin-right: 0;
          }
          &:nth-child(2):hover {
            text-decoration: underline;
          }
          &:last-child:hover {
            text-decoration: underline;
          }
        }
      }
      .copyright-mobile {
        display: none;
        width: 7.4667rem;
        text-align: center;
        .copyright-p {
          margin-right: 14px;
        }
      }
    }
    .login-form {
      width: 464px;
      margin: 40px auto 0;
      .login-title {
        display: flex;
        justify-content: space-between;
        color: #303133;
        margin-bottom: 24px;
        & div:first-child {
          font-size: 38px;
          font-weight: 600;
          line-height: 46px;
        }
        .signup {
          display: none;
        }
      }
      .el-form-item {
        margin-bottom: 24px;
      }
      .login-input {
        .el-input__inner {
          font-size: 16px;
          height: 48px;
          line-height: 48px;
        }
        .el-input-group__append {
          padding: 0;
        }
      }
      .remember-box {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .remember-label {
          display: inline-block;
          font-size: 14px;
          color: #606266;
        }
        .el-checkbox__inner {
          width: 16px;
          height: 16px;
          &::after {
            left: 5px;
            top: 2px;
          }
        }
      }
      #remember {
        margin-right: 12px;
      }
      .forget {
        cursor: pointer;
        color: #1861f2;
      }
      .login-btn {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        background: #e30077;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        border-style: none;
      }
      .login-btn::before {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    .verify-form {
      width: 464px;
      margin: 40px auto 0;
      color: #303133;
      .verify-content {
        // background: #ffffff;
        // border: 1px solid #ebeef5;
        border-radius: 8px;
        padding: 32px;
        .verify-sub-tit {
          // text-align: center;
          margin-bottom: 24px;
          i {
            vertical-align: 2px;
          }
          label {
            font-size: 30px;
            font-weight: 600;
            line-height: 38px;
          }
        }
        .check {
          font-weight: 600;
          line-height: 30px;
          font-size: 20px;
        }
        .email {
          color: #1861f2;
          font-weight: 600;
          line-height: 30px;
        }
        .desc {
          color: #606266;
          line-height: 30px;
          margin-bottom: 24px;
          font-size: 17px;
        }
        .btn-area {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .verify-btn {
            font-size: 14px;
            font-weight: bold;
            width: 100%;
            height: 40px;
            color: #ffffff;
            border-radius: 4px;
            border: none;
            margin-left: 0 !important;
            margin-bottom: 14px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .verify-btn::before {
            background-color: rgba(255, 255, 255, 0.2);
          }
          .back-login {
            background: #1861f2;
          }
          .go-check {
            background: #e30077;
          }
        }
        .no-email {
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
          a {
            color: #1861f2;
          }
        }
      }
    }

    .no-email-form {
      width: 464px;
      color: #303133;
      margin: 40px auto 0;
      .no-email-title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        & div:first-child {
          font-size: 38px;
          font-weight: 600;
          line-height: 46px;
        }
      }
      .no-email-content {
        // background: #ffffff;
        // border: 1px solid #ebeef5;
        border-radius: 8px;
        // padding: 32px;
        padding: 32px 23px;
        .email {
          color: #1861f2;
          font-weight: 600;
          line-height: 30px;
        }
        a {
          color: #1861f2;
          font-size: 16px;
        }
        .no-email-sub-tit {
          // text-align: center;
          color: #303133;
          height: 38px;
          line-height: 38px;
          margin-bottom: 24px;
          i.icon-y-yiwen1 {
            vertical-align: 2px;
          }
          .sub-tit {
            font-size: 30px;
            font-weight: 600;
          }
        }
        .solutions {
          color: #303133;
          font-size: 16px;
          font-weight: 600;
          line-height: 30px;
        }
        .solutions-content {
          color: #606266;
          line-height: 30px;
          font-size: 16px;
        }
        .back-login {
          width: 100%;
          height: 40px;
          background: #1861f2;
          border-radius: 4px;
          margin-top: 24px;
          border: none;
          color: #ffffff;
          font-size: 14px;
          font-weight: bold;
        }
        .back-login::before {
          background: rgba(255, 255, 255, 0.2);
        }
      }
    }

    .reset-psw-form {
      width: 464px;
      margin: 40px auto 0;
      .reset-psw-title {
        color: #303133;
        margin-bottom: 24px;
        & div:first-child {
          font-size: 38px;
          font-weight: 600;
          line-height: 46px;
        }
        & div:last-child {
          font-size: 20px;
          font-weight: 400;
          line-height: 28px;
        }
      }
      .el-form-item {
        margin-bottom: 24px;
      }
      .reset-psw-input {
        .el-input__inner {
          font-size: 16px;
          height: 48px;
          line-height: 48px;
        }
        .el-input-group__append {
          padding: 0;
        }
      }
      .reset-psw-btn {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        background: #1861f2;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        border-style: none;
        margin-top: 16px;
      }
      .reset-psw-btn::before {
        background: rgba(255, 255, 255, 0.2);
      }
      .reset-psw-back {
        text-align: center;
        margin-top: 16px;
        a {
          color: #1861f2;
        }
      }
    }

    .reset-psw-success {
      width: 464px;
      height: 362px;
      // background: #fff;
      border-radius: 8px;
      // border: 1px solid rgba(235, 238, 245, 1);
      margin: 80px auto 0;
      box-sizing: border-box;
      padding: 32px;
      h2 {
        // text-align: center;
        font-size: 30px;
        color: #303133;
        margin: 0 0 24px 0;
        i {
          color: #77b300;
          font-size: 24px;
          vertical-align: 2px;
          display: none;
        }
      }
      .sub-tit {
        color: #303133;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 4px;
        font-size: 20px;
      }
      .email {
        color: #1861f2;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 12px;
        font-size: 16px;
      }
      .content {
        color: #606266;
        line-height: 30px;
        margin-bottom: 24px;
        padding: 0;
        font-size: 16px;
      }
      .check-btn {
        width: 100%;
        height: 40px;
        background: #e30077;
        font-weight: bold;
        border-radius: 4px;
        border: none;
        margin-bottom: 8px;
      }
      .check-btn::before {
        background: rgba(255, 255, 255, 0.2);
      }
      .no-received {
        color: #1861f2;
        display: block;
        width: 125px;
        margin: 0 auto;
      }
    }
  }
  .el-input-group__prepend {
    .el-input {
      width: 142px;
    }
  }
  .captcha-send-code {
    .el-input-group__append {
      width: 98px;
      height: 48px;
      background: #e9077c;
      border-radius: 0px 4px 4px 0px;
      color: #ffffff;
      text-align: center;
      border: none;
      cursor: pointer;
    }
    .send-code {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      #sending {
        display: none;
      }
    }
  }

  .el-tabs__header {
    .el-tabs__active-bar {
      background-color: #e30077 !important;
    }
    .el-tabs__item.is-active {
      color: #e30077 !important;
    }
    .el-tabs__item:hover {
      color: #e30077 !important;
    }
  }

  @media screen and (max-width: 1270px) {
    .aside {
      width: 50% !important;
    }
  }
  @media screen and (max-width: 1000px) {
    .aside {
      display: none;
    }
  }
}
.ym-label {
  display: inline-block;
  font-size: 16px;
  color: #606266;
  margin-bottom: 8px;
}
@media screen and (max-width: 901px) {
  .login {
    .content {
      // padding: .4267rem;
      padding: 0;
      .login-banner {
        // display: block;
        > img {
          width: 100%;
          min-height: 125px;
          height: 125px;
        }
      }
      .header {
        display: block;
        height: auto;
        padding: 0.4267rem;
        padding-bottom: 0;
        .logo {
          margin-left: 0;
          // margin-bottom: .8rem;
          .logo-img {
            width: 160px;
            height: 28px;
          }
        }
        .rightWrap {
          display: none;
          justify-content: space-between;
          .langBtn {
            display: none;
          }
          .rightWrap-text {
            display: block;
            font-size: 38px;
            font-weight: 600;
            color: #303133;
          }
        }
        .signup {
          font-size: 16px;
          font-weight: 400;
        }
      }
      .scroll {
        padding: 0.4267rem;
        padding-bottom: 0;
      }
      .main-container {
        padding-top: 0;
        .login-form {
          .login-title {
            .signup {
              display: flex;
              justify-content: center;
              justify-content: center;
              width: 80px;
              height: 32px;
              border-radius: 4px;
              background: #e30077;
              color: #fff;
              font-size: 14px;
              font-weight: bold;
              line-height: 32px;
              text-align: center;
            }
            .signup::before {
              background-color: rgba(255, 255, 255, 0.2);
            }
          }
          .ym-label {
            display: none;
          }
        }
      }
    }
    .lang-switch-wrap {
      display: flex !important;
      width: 100%;
      justify-content: center;
      margin-top: 1.0667rem;
      .lang-switch {
        width: 72px;
        height: 30px;
        border-radius: 15px;
        opacity: 1;
        border: 1px solid rgba(24, 97, 242, 0.3);
        display: flex;
        align-items: center;
        padding: 0 4px;
        .lang-icon {
          width: 50%;
          font-size: 14px;
          color: #1861f2;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        .langActive {
          width: 35px;
          height: 22px;
          background: #1861f2;
          border-radius: 12px;
          color: #fff;
        }
      }
    }
    .copyright {
      display: none;
    }
    .copyright-mobile {
      display: block !important;
      margin-bottom: 45px;
      padding-bottom: 180px;
    }
  }
  .login .content .verify-form .verify-content .email {
    font-size: 20px;
  }
  .login .content .no-email-form .no-email-content .email {
    font-size: 18px;
  }
}

@media screen and (max-width: 701px) {
  .login {
    .copyright-mobile {
      text-align: center;
      padding-bottom: 180px;
      .copyright-p {
        &:first-child {
          display: block;
        }
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .login {
    .content {
      .main-container {
        .login-form {
          width: calc(100% - 0.8534rem);
        }
        .verify-form {
          width: calc(100% - 0.8534rem);
          .verify-content {
            padding: 0;
            .btn-area .verify-btn:last-child {
              margin-bottom: 14px;
            }
          }
        }
        .no-email-form {
          width: calc(100% - 0.8534rem);
          .no-email-content {
            padding: 0;
            .back-login {
              margin-bottom: 14px;
            }
          }
        }
        .reset-psw-form {
          width: calc(100% - 0.8534rem);
        }
        .reset-psw-success {
          width: calc(100% - 0.8534rem);
          padding: 0;
          margin-top: 40px;
          .email,
          .content {
            // font-size: 18px;
          }
        }
      }
    }
    .copyright-mobile {
      padding-bottom: 180px;
    }
  }
}
</style>
